export const NAV_ITEMS = [
  { section: "Overview", items: [
    { key: "dashboard", label: "Dashboard", to: "/", icon: "LayoutDashboard" },
    { key: "analytics", label: "Analytics", to: "/analytics", icon: "BarChart3" },
  ]},
  { section: "Brand & Layout", items: [
    { key: "site-settings", label: "Brand & Pages", to: "/site-settings", icon: "Globe" },
    { key: "home-builder", label: "Home Builder", to: "/home-builder", icon: "LayoutTemplate" },
    { key: "navigation", label: "Navigation", to: "/navigation", icon: "Menu" },
    { key: "media", label: "Media Library", to: "/media", icon: "Image" },
  ]},
  { section: "Services & Process", items: [
    { key: "services", label: "Services", to: "/services", icon: "Wrench" },
    { key: "service-showcases", label: "Service Showcases", to: "/service-showcases", icon: "Layers" },
    { key: "why-choose", label: "Why Choose Us", to: "/why-choose", icon: "Award" },
    { key: "process", label: "Process Steps", to: "/process", icon: "ListOrdered" },
    { key: "challenges", label: "Challenges", to: "/challenges", icon: "Target" },
  ]},
  { section: "Trust & Proof", items: [
    { key: "portfolio", label: "Portfolio", to: "/portfolio", icon: "Briefcase" },
    { key: "pricing", label: "Pricing", to: "/pricing", icon: "CreditCard" },
    { key: "stats", label: "Stats & Counters", to: "/stats", icon: "TrendingUp" },
    { key: "logos", label: "Client Logos", to: "/logos", icon: "Image" },
    { key: "testimonials", label: "Testimonials", to: "/testimonials", icon: "Quote" },
    { key: "industries", label: "Industries", to: "/industries", icon: "Building2" },
  ]},
  { section: "People & Content", items: [
    { key: "team", label: "Team", to: "/team", icon: "Users" },
    { key: "blog", label: "Blog", to: "/blog", icon: "FileText" },
    { key: "blog-categories", label: "Blog Categories", to: "/blog-categories", icon: "Tags" },
    { key: "faq", label: "FAQ", to: "/faq", icon: "HelpCircle" },
    { key: "banners", label: "Banners", to: "/banners", icon: "Megaphone" },
    { key: "popups", label: "Popups", to: "/popups", icon: "Square" },
  ]},
  { section: "Growth", items: [
    { key: "leads", label: "Leads", to: "/leads", icon: "Inbox" },
  ]},
  { section: "SEO", items: [
    { key: "seo", label: "Start here", to: "/seo", icon: "Gauge" },
    { key: "seo-pages", label: "Pages", to: "/seo/pages", icon: "FileSearch" },
    { key: "seo-issues", label: "Problems", to: "/seo/issues", icon: "ListTodo" },
    { key: "seo-advanced", label: "More tools", to: "/seo/advanced", icon: "SlidersHorizontal" },
  ]},
  { section: "Administration", items: [
    { key: "ux-audit", label: "UX Audit", to: "/ux-audit", icon: "ClipboardList" },
    { key: "users", label: "Users", to: "/users", icon: "UserCog" },
    { key: "roles", label: "Roles & Permissions", to: "/roles", icon: "ShieldCheck" },
    { key: "activity", label: "Activity Logs", to: "/activity", icon: "Activity" },
    { key: "settings", label: "Settings", to: "/settings", icon: "Settings" },
  ]},
];

function flattenNav(items) {
  const out = [];
  for (const it of items) {
    if (it.to) out.push(it);
    if (it.children) out.push(...flattenNav(it.children));
  }
  return out;
}

export const ALL_NAV_ITEMS = NAV_ITEMS.flatMap((s) => flattenNav(s.items));
